/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRefreshAlert = createReactComponent("outline", "refresh-alert", "IconRefreshAlert", [["path", { "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4", "key": "svg-0" }], ["path", { "d": "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4", "key": "svg-1" }], ["path", { "d": "M12 9l0 3", "key": "svg-2" }], ["path", { "d": "M12 15l.01 0", "key": "svg-3" }]]);

export { IconRefreshAlert as default };
//# sourceMappingURL=IconRefreshAlert.mjs.map
